require('./animations')
require('./VideoPlayer')
require('./HeroPlayer')
require('./ThumbPlayer')
require('./social-sticky')
require('./infinite-scroll-news')
require('./menu-bg')
require('./animation-write')
require('./category-news-select')
require('./navigation-v2')
require('./static-pages')
require('./parallax')
require('./sticky-dropdown')

